import Request from '@transsion/request'
import { showToast } from '@/components/toast'
import i18n, { getLocale } from '@/lang'
import { logout, store } from '@/utils'
import type { ResponseData } from '@/types/base'

export const TOKEN_KEY = 'tomee_m_token'
export const REFRESH_TOKEN_KEY = 'tomee_m_refreshToken'

// TOKEN_EXPIRED("1001001", "token过期"),
// CHECK_TOKEN("1001003", "校验token异常"),
const InvalidTokenCodeList = new Set(['1001001', '1001002', '1001003'])

const req = new Request<ResponseData<any>>({
  baseURL: import.meta.env.VITE_BASE_API,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 600
})

req.addEventListener('error', function errorHandler(err) {
  const responseData = err.cause?.response

  showToast(responseData?.data?.message || err.message || i18n.t('tips.serve.error.msg'), {
    duration: 3000
  })
})

req.addRequestInterceptors({
  callback: (meta) => {
    meta.headers['T-Auth'] = store.getStore(TOKEN_KEY)
    meta.headers['T-RToken'] = store.getStore(REFRESH_TOKEN_KEY)
    meta.headers['T-LangId'] = getLocale()
    meta.headers['T-ClientId'] = 4

    return meta
  }
})

req.addResponseInterceptors(async (response) => {
  const { config, data } = response

  if (config.responseType === 'blob') return response

  if (InvalidTokenCodeList.has(data?.code)) {
    showToast(i18n.t('tips.token.error'))
    logout()
  }

  return data
})

export default req
